module.exports = __webpack_public_path__ + "media/images/contrato-color-aa766bbd5537290196e7aec17733b89b.png";